import { ProjectBase } from './project-base';
import { IEntity } from './entity';
import { IJobCode } from './job-code';
import { Employee } from './employee';
import { WarningType } from './warning-type';
export class Timesheet{
  id: number;
  day: Date;
  jobCode: IJobCode;
  employee: Employee;
  hours: number;
  shift: IEntity;
  note:string;
  payrollRosterCodeId?: number;
  payrollRosterCode?: string;
  totalHours?: number;
  warningMessage?: string;
  warningType?: WarningType;
}
